export default __webpack_public_path__ + "static/media/remove.ce57e98f.svg";